import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { consultarDadosPreCadastro, consultarIntegrantePreCadastro } from '../../../api/preCadastroAPI';
import { RootState } from '../../../app/store';

export interface ConsultaPreCadastroState {
  preFamilia: any;
  dadosIntegranteSelecionado: any;
  integranteConsultado: any;
  exibirTelaMensagem: boolean;
}

const initialState: ConsultaPreCadastroState = {
  preFamilia: null,
  dadosIntegranteSelecionado: null,
  integranteConsultado: null,
  exibirTelaMensagem: true
};

export const consultarPreCadastro = createAsyncThunk(
  'consultaPreCadastroState/consultarPreCadastro',
  async (idPreFamilia: number) => {
    return consultarDadosPreCadastro(idPreFamilia);
  }
);

export const consultarIntegrante = createAsyncThunk(
  'consultaPreCadastroState/consultarIntegrante',
  async (data: any) => {
    return consultarIntegrantePreCadastro(data.integranteSelecionado.id);
  }
);

export const consultaPreCadastroSlice = createSlice({
  name: 'consultaPreCadastroState',
  initialState,
  reducers: {
    setIntegranteSelecionado: (state, action) => {
      state.dadosIntegranteSelecionado = action.payload;
    },
    setTelaMensagem: (state, action) => {
      state.exibirTelaMensagem = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(consultarPreCadastro.fulfilled, (state, action) => {
      state.preFamilia = action.payload;
    });
    builder.addCase(consultarIntegrante.fulfilled, (state, action) => {
      state.integranteConsultado = action.payload;
    });
  },
});

export const {setIntegranteSelecionado, setTelaMensagem} = consultaPreCadastroSlice.actions;

export const selectDadosPreFamilia = (state: RootState) => state.consultaPreCadastro.preFamilia;
export const selectExibirTelaMensagem = (state: RootState) => state.consultaPreCadastro.exibirTelaMensagem;
export const selectDadosIntegranteSelecionado = (state: RootState) => state.consultaPreCadastro.dadosIntegranteSelecionado;
export const selectIntegranteConsultado = (state: RootState) => state.consultaPreCadastro.integranteConsultado;

export default consultaPreCadastroSlice.reducer;
